export {default as BadgerPrideWall} from "./BadgerPrideWallData.json";


// WEBPACK FOOTER //
// ./src/data/index.js